var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.43531024,13.3070988 C4.66088649,14.3621903 6.25595903,15 8,15 C9.74607633,15 11.3428363,14.3607007 12.5689791,13.3034031 C12.5784707,13.2484185 12.5833333,13.19204 12.5833333,13.1342593 C12.5833333,11.7614727 10.3095331,10.3333333 8,10.3333333 C5.77936486,10.3333333 3.41666667,11.8731794 3.41666667,13.1342593 C3.41666667,13.1930504 3.42300348,13.2506745 3.43531024,13.3070988 Z M2.63724433,12.4992359 C3.23451713,10.998238 5.68147691,9.6 8,9.6 C10.4123889,9.6 12.8098444,10.9150832 13.3751757,12.4844063 C14.3895638,11.2698355 15,9.70620524 15,8 C15,4.13400675 11.8659932,1 8,1 C4.13400675,1 1,4.13400675 1,8 C1,9.71315751 1.61542103,11.2825757 2.63724433,12.4992359 Z M8,9 C6.32933863,9 4.975,7.69566137 4.975,6.025 C4.975,4.35433863 6.32933863,3 8,3 C9.67066137,3 11.025,4.35433863 11.025,6.025 C11.025,7.69566137 9.67066137,9 8,9 Z M8,8.31666667 C9.26565255,8.31666667 10.2916667,7.29065255 10.2916667,6.025 C10.2916667,4.75934745 9.26565255,3.73333333 8,3.73333333 C6.73434745,3.73333333 5.70833333,4.75934745 5.70833333,6.025 C5.70833333,7.29065255 6.73434745,8.31666667 8,8.31666667 Z M8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 Z",
    id: "Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.8c5460dd19e3fee03f9d0a78fb12a287.svg";
export { ForwardRef as ReactComponent };